import { Entity, EntityContext, GenericFieldValue, ListValue, StringValue } from '@msdk/definitions'

export function filtersToObject(
  filterString: string,
  entity: Entity | EntityContext | null,
  listName?: string,
  rowId?: string,
): Record<string, GenericFieldValue> {
  const filters: Record<string, GenericFieldValue> = {}
  if (filterString && filterString !== '') {
    const sanitized = filterString.replace(/\s/g, '')
    const pairs = sanitized.split(';')
    pairs.forEach((s) => {
      const splitted = s.split('=')
      const paramKey = splitted[0]
      const fieldName = splitted[1]
      filters[paramKey] = createFilter(fieldName, entity, listName, rowId)
    })
  }
  return filters
}

function createFilter(
  fieldName: string,
  entity: Entity | EntityContext | null,
  listName?: string,
  rowId?: string,
): GenericFieldValue {
  if (fieldName === 'Id') {
    return filterById(entity)
  }

  if (fieldName.startsWith('row.')) {
    return fiterByRowOfList(fieldName, entity, listName as string, rowId as string)
  }

  return filterByField(fieldName, entity)
}

function filterById(entity: Entity | EntityContext | null): GenericFieldValue {
  return new StringValue(entity?.id as string)
}

function fiterByRowOfList(
  fieldName: string,
  entity: Entity | EntityContext | null,
  listName: string,
  rowId: string,
): GenericFieldValue {
  fieldName = fieldName.replace('row.', '')
  const listValue = entity?.fields[listName as string] as ListValue //dosn't work with lists of lists
  const rows = listValue?.value as Entity[]
  const row = rows?.find((r) => r.id == rowId)
  return row?.fields[fieldName] as GenericFieldValue
}

function filterByField(fieldName: string, entity: Entity | EntityContext | null) {
  return entity?.fields[fieldName] as GenericFieldValue
}
